import React, { useEffect, useState,useCallback,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useAlert } from 'react-alert';
import { Card } from '../minor-components/Card';
import { Footer } from './Footer';
import { Loader } from '../minor-components/Loader';
import { DashboardProducts } from '../minor-components/DashboardProducts';
import { SlickSliderForHeaderImages } from '../minor-components/SlickSlider';
import { getBlogs } from '../../redux/Actions/BlogsActions';
import { selectProgressBarState } from '../../redux/Actions/ProgressBarActions';
import { axiosInstance } from "../../constants/axiosInstance";
import { baseURL } from '../../constants/baseURL';
import BottomImage from '../../assets/second-hero-section.png';
import CertificateIcon from '../fontawesomeIcons/quality.png';
import RocketIcon from '../fontawesomeIcons/charity.png';
import CharityIcon from '../fontawesomeIcons/innovation.png';
import LightbulbIcon from '../fontawesomeIcons/mission.png';
import SafetyIcon from '../fontawesomeIcons/safety.png';
import { motion } from 'framer-motion';
import TrendingProducts from '../minor-components/TrendingProducts';
import { getFeaturedProducts } from '../../redux/Actions/ProductActions';
import Reviews from './Reviews';

export const HeroSection = (setSearchQuery, searchQuery, setLoading) => {
  const [productsWithShopNames, setProductsWithShopNames] = useState([]);
  const [alertShown, setAlertShown] = useState(false); // Initialize state to track alert
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const alert = useAlert();
  const [products, setProducts] = useState([]);
  const [editSliderPreview, setEditSliderFilePreview] = useState('');
  const [categories, setCategories] = useState([]);
  const { blogs } = useSelector((state) => state.blogReducer);
  const loading = useSelector((state) => state.ProgressBarReducer);
  const { featuredProducts } = useSelector((state) => state.productReducer);
  const progressBarLoading = useSelector((state) => state.ProgressBarReducer);

   // Add refs for scrolling
   const categoriesRef = useRef(null);
   const blogsRef = useRef(null);

   const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    const initData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          dispatch(getBlogs()),
          fetchProducts(),
          getHeaderImages()
        ]);
      } finally {
        setIsLoading(false);
      }
    };
    
    initData();
  }, []);

  useEffect(() => {
    dispatch(getFeaturedProducts());
}, [dispatch]);



  const getHeaderImages = async () => {
    try {
      const res = await axiosInstance.get('/api/v1/headerimages/getHeaderImages');
      if (res.data.data.length > 0) {
        setEditSliderFilePreview(res.data.data[0].sliderPhoto);
      }
    } catch (err) {
      console.error("Error fetching header images:", err);
    }
  };
  
  const updateCartCount = useCallback((count) => {
    localStorage.setItem('totalCart', count);
    dispatch({ type: 'UPDATE_CART_COUNT', payload: count });
  }, [dispatch]);

  const handleItem = useCallback(async (item, action = 'add') => {
    setLoading(true);

    const fadeIn = {
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: 0.6 }
    };
  
    const staggerChildren = {
      animate: {
        transition: {
          staggerChildren: 0.1
        }
      }
    };
  
    
    // Log the item to ensure shopName exists before sending to API
    console.log('HandleItem called with:', JSON.stringify(item, null, 2));
    console.log('Item shopName before API call:', item.shopName);
  
    if (!item.shopName) {
     // console.error('Product does not have a shop name:', item);
      alert.show("Unable to add product. Shop information is missing.");
      setLoading(false);
      return;
    }
  
    const details = {
      productId: item._id,
      quantity: 1,
      shopName: item.shopName,  // Ensure shopName is correctly sent here
      extras: item.extras || []
    };
  
    // Log the details object being sent to the API
    //console.log('Details object being sent to API:', JSON.stringify(details, null, 2));
  
    const url = action === 'add' ? '/api/v1/order/addtocart' : '/api/v1/order/decreasecartquantity';
  
    try {
      const token = localStorage.getItem('token');
  
      if (!token) {
        throw new Error('Authorization token is missing.');
      }
  
      const res = await axiosInstance.post(url, details, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": token
        }
      });
  
      // Log the API response
      //console.log('API Response:', JSON.stringify(res.data, null, 2));
  
      if (res.data && res.data.success) {
        const cartCount = res.data.data.details.length;
        updateCartCount(cartCount);
  
        const message = action === 'add' ? "Product Added to Cart" : "Product Removed from Cart";
        alert.show(message);
  
        setSearchQuery(prev => !prev);
      } else {
        throw new Error(res.data.message || "Failed to update cart");
      }
    } catch (err) {
      console.error('Error updating cart:', err);
      alert.show(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [setLoading, setSearchQuery, alert, updateCartCount]);


  
  const fetchProducts = async () => {
    dispatch(selectProgressBarState(true));
    try {
      const [productsData, categoriesData, shopData] = await Promise.all([
        axiosInstance.get("/api/v1/product/getproducts"),
        axiosInstance.get('/api/v1/category/getcategories'),
        axiosInstance.get('/api/v1/admin/getradius')
      ]);
  
      // Set categories directly from the API response
      setCategories(categoriesData.data.data);
  
      const shopDetails = shopData.data.data.reduce((acc, shop) => {
        acc[shop._id] = shop.shopName;
        return acc;
      }, {});
  
      const productsWithShopNames = productsData.data.data
        .filter(product => shopDetails[product.shopid])
        .map(product => ({
          ...product,
          shopName: shopDetails[product.shopid]
        }));
  
      setProductsWithShopNames(productsWithShopNames);
  
    } catch (error) {
      console.error("Error fetching data:", error);
      alert.show("Something Went Wrong.");
    } finally {
      dispatch(selectProgressBarState(false));
    }
  };
      

  const AllProductsSection = React.memo(({ products, handleItem }) => {
   // console.log('AllProductsSection products:', products);
    return (
      <div className='w-[90vw] mx-auto my-10'>
        <h1 className='text-primaryText font-bold text-2xl my-10'>All Products</h1>
        <div className='grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-3 grid-cols-2 gap-3'>
          {products.map((item, index) => {
            console.log(`Product ${index}:`, item);
            return (
              <div key={item._id} className='px-2 py-2'>
                <Card
                  svg={`${baseURL}${item.productPhoto}`}
                  title={item.name}
                  desc={item.description}
                  price={item.price}
                  item={item}
                  value={index}
                  shopName={item.shopName}
                  getItem={() => {
                    console.log('getItem called with:', item);
                    handleItem(item);
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  });
  
  {/*const ProductsUnder40Section = React.memo(({ products, handleItem }) => {
    console.log('ProductsUnder40Section products:', products);
    return (
      <div className='w-[90vw] mx-auto my-10'>
        <h1 className='text-primaryText font-bold text-2xl my-10'>Products Under $40</h1>
        <div className='grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-3 grid-cols-2 gap-3'>
          {products.filter(item => item.price < 40).map((item, index) => {
            console.log(`Product Under 40 ${index}:`, item);
            return (
              <div key={item._id} className='px-2 py-2'>
                <Card
                  svg={`${baseURL}${item.productPhoto}`}
                  title={item.name}
                  desc={item.description}
                  price={item.price}
                  item={item}
                  value={index}
                  shopName={item.shopName}
                  getItem={() => {
                    console.log('getItem called with:', item);
                    handleItem(item);
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  });
  */}
  const handleHeaderImage = (brand) => {
    if (brand === 'vapes') {
      navigate('/brand/vapes');
    } else if (brand === 'flowers') {
      navigate('/brand/flowers');
    }
  };
  
  
  
  
  const SparklesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
      <path d="M5 3v4"/>
      <path d="M19 17v4"/>
      <path d="M3 5h4"/>
      <path d="M17 19h4"/>
    </svg>
  );
  
  const LeafIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/>
      <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>
    </svg>
  );
  
  const AwardIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="6"/>
      <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
    </svg>
  );
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };
  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const scaleIn = {
    initial: { scale: 0.9, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    transition: { duration: 0.5 }
  };
  
      
  return isLoading || progressBarLoading ? <Loader /> : (
    <>
      {/* Hero Banner */}
      <motion.div 
        className="relative h-screen overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
      >
        <motion.div 
          className="absolute inset-0 bg-gradient-to-r from-purple-900/70 to-blue-900/70 z-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        />
        <motion.img 
          src={editSliderPreview !== '' ? baseURL + editSliderPreview : BottomImage}
          className="w-full h-full object-cover scale-105"
          initial={{ scale: 1.2 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.5 }}
          alt="Hero"
        />
        <motion.div 
          className="absolute inset-0 z-20 flex items-center justify-center text-white text-center"
          variants={staggerContainer}
          initial="initial"
          animate="animate"
        >
          <div className="max-w-4xl px-4">
            <motion.h1 
              className="text-6xl md:text-8xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-white to-purple-200"
              variants={fadeInUp}
            >
              Discover Excellence
            </motion.h1>
            <motion.p 
              className="text-xl md:text-3xl mb-8 text-purple-100"
              variants={fadeInUp}
            >
              Experience our premium collection
            </motion.p>
            <motion.div variants={fadeInUp} className="flex gap-4 justify-center">
          <button 
            onClick={() => scrollToSection(categoriesRef)}
            className="px-8 py-3 bg-white text-purple-900 rounded-full font-bold hover:bg-purple-100 transition-all transform hover:scale-105"
          >
            Shop Now
          </button>
          <button 
            onClick={() => scrollToSection(blogsRef)}
            className="px-8 py-3 border-2 border-white text-white rounded-full font-bold hover:bg-white/10 transition-all"
          >
            Learn More
          </button>
            </motion.div>
          </div>
        </motion.div>
        
        {/* Floating Elements */}
        <motion.div
          className="absolute bottom-10 left-10 z-30 flex gap-6"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 1 }}
        >
          {['Quality', 'Premium', 'Authentic'].map((text, index) => (
            <div key={index} className="px-6 py-2 bg-white/10 backdrop-blur-md rounded-full text-white border border-white/20">
              {text}
            </div>
          ))}
        </motion.div>
      </motion.div>
      {/* Featured Products Section */}
      <motion.div 
            className="w-[90vw] mx-auto my-20"
            variants={staggerContainer}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
        >
            <motion.h2 
                className="text-4xl font-bold mb-12 text-purple-900"
                variants={fadeInUp}
            >
                Featured Products
            </motion.h2>
            
            {featuredProducts?.length > 0 ? (
                <motion.div 
                    className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-8"
                    variants={scaleIn}
                >
                    {featuredProducts.map((product, index) => (
                        <motion.div
                            key={product._id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1 }}
                        >
                            <Card
                                svg={`${baseURL}${product.productPhoto}`}
                                title={product.name}
                                desc={product.description}
                                price={product.price}
                                item={product}
                                shopName={product.shopid?.name} // Assuming shop name is in shopid
                                getItem={() => handleItem(product)}
                            />
                        </motion.div>
                    ))}
                </motion.div>
            ) : (
                <div className="text-center py-8 text-gray-600">
                    No featured products available at the moment
                </div>
            )}
        </motion.div>
      {/* Categories Section */}
      <motion.div 
        ref={categoriesRef}
        className="w-full py-20 bg-gradient-to-b from-purple-50 to-white"
        variants={staggerContainer}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }}
      >
       <motion.div className="w-[95vw] mx-auto">
            <motion.h2 
            className="text-4xl font-bold mb-12 text-purple-900"
            variants={fadeInUp}
          >
            Explore Categories
          </motion.h2>
          <motion.div variants={scaleIn}>
            <DashboardProducts 
              products={categories} 
              istype="categories"
              className="grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 gap-4" 
              />
          </motion.div>
      </motion.div>
      </motion.div>
   {/* Categories Section - Now using the new component */}
      {/* New Trending Products Section */}
      <TrendingProducts handleItem={handleItem} />



      {/* Customer Reviews Section */}
      <Reviews isHomePage={true} />


      {/* Features Grid */}
      <motion.div 
        className="grid grid-cols-1 md:grid-cols-5 gap-8 p-16 bg-gradient-to-r from-purple-900 to-blue-900 text-white"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        {[
          { icon: CertificateIcon, title: "Quality", desc: "Premium grade products" },
          { icon: SafetyIcon, title: "Safety", desc: "Certified standards" },
          { icon: LightbulbIcon, title: "Innovation", desc: "Leading technology" },
          { icon: RocketIcon, title: "Service", desc: "24/7 support" },
          { icon: CharityIcon, title: "Community", desc: "Supporting causes" }
        ].map((item, index) => (
          <motion.div 
            key={index}
            className="flex flex-col items-center text-center p-6 rounded-xl backdrop-blur-lg bg-white/5 hover:bg-white/10 transition-all"
            whileHover={{ y: -10, scale: 1.05 }}
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1 }}
          >
            <img src={item.icon} alt={item.title} className="w-16 h-16 mb-4" />
            <h3 className="text-xl font-bold mb-2">{item.title}</h3>
            <p className="text-purple-200">{item.desc}</p>
          </motion.div>
        ))}
      </motion.div>

      {/* Vapes Section */}
      <motion.div 
        className="relative my-10"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <SlickSliderForHeaderImages>
          <div className="relative">
            <img
              src={editSliderPreview !== '' ? baseURL + editSliderPreview : BottomImage}
              className="w-full h-[50vh] object-cover"
              alt="Vapes"
            />
            <motion.div 
              className="absolute inset-0 bg-slate-50/70 flex items-center p-5"
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <div className="w-96 bg-slate-50 p-5 rounded-3xl">
                <h2 className="text-2xl text-primaryColor font-bold mb-4">Vapes to Go</h2>
                <p className="mb-4">Disposable vapes are all charged up and ready to stroll</p>
                <button 
                  onClick={() => handleHeaderImage('vapes')} 
                  className="rounded-md font-semibold text-lg py-2 px-6 bg-[#3A3A3A] text-white hover:bg-[#4A4A4A] transition-colors"
                >
                  Vapes
                </button>
              </div>
            </motion.div>
          </div>
        </SlickSliderForHeaderImages>
      </motion.div>

      {/* Company Info Section */}
<motion.div 
  className="w-full min-h-[70vh] font-sans bg-white"
 initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
>
  <div className="flex flex-col lg:flex-row">
    <div className="lg:w-1/2 p-8 lg:p-16 flex flex-col justify-center">
      <motion.h1 
        className="text-4xl lg:text-5xl font-bold mb-8"
        initial={{ y: 20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
      >
        Plant-powered wellness,<br />100% clean ingredients.
      </motion.h1>
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
      >
        <p className="mb-4 text-lg">
          In a world where people face a relentless barrage of marketing, social media,
          and so called Next Big Things, we want to distill things down to their essence.
        </p>
        <p className="mb-4 text-lg">
          At Good Puff, our expert botanists distill hemp to its purest essence and
          create targeted formulations to help people calibrate their health.
        </p>
        <p className="font-semibold mb-6 text-xl">Good Puff. Quality that Matters</p>
        
        <div className="flex justify-between gap-6 text-center text-green-500">
          <IconFeature Icon={SparklesIcon} text="100% Clean Ingredients" />
          <IconFeature Icon={LeafIcon} text="US-Grown Hemp" />
          <IconFeature Icon={AwardIcon} text="Quality Assured" />
        </div>
      </motion.div>
    </div>
    <motion.div 
      className="lg:w-1/2 h-[50vh] lg:h-auto"
      initial={{ x: 100, opacity: 0 }}
      whileInView={{ x: 0, opacity: 1 }}
      viewport={{ once: true }}
    >
      <img 
        src="/homepage.jpg"
        alt="CBD Products" 
        className="w-full h-full object-cover" 
      />
    </motion.div>
  </div>
</motion.div>

{/* Flowers Section */}
<motion.div 
 className="relative bg-white"
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  viewport={{ once: true }}
>
  <SlickSliderForHeaderImages>
    <div className="relative">
      <img
        src={editSliderPreview !== '' ? baseURL + editSliderPreview : BottomImage}
        className="w-full h-[70vh] object-cover"
        alt="Flowers"
      />
      <motion.div 
        className="absolute inset-0 bg-slate-50/70 flex items-center p-5"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <div className="w-96 bg-slate-50 p-5 rounded-3xl">
          <h2 className="text-2xl text-primaryColor font-bold mb-4">Flowers to Go</h2>
          <p className="mb-4">Disposable Flower are all charged up and ready to stroll</p>
          <button 
            onClick={() => handleHeaderImage('flowers')} 
            className="rounded-md font-semibold text-lg py-2 px-6 bg-[#3A3A3A] text-white hover:bg-[#4A4A4A] transition-colors"
          >
            Flowers
          </button>
        </div>
      </motion.div>
    </div>
  </SlickSliderForHeaderImages>
</motion.div>

      {/* Blog Section */}
      {blogs.length > 0 && (
        <motion.div 
        ref={blogsRef}
        className="w-[90vw] mx-auto py-16 bg-white"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
         <h2 className="text-primaryText font-bold text-2xl mb-10">
            LATEST FROM THE BLOG
          </h2>
          <DashboardProducts blogs={blogs} isBlogType={true} />
        </motion.div>
      )}

      <Footer />
    </>
  ) ; (
    <Loader />
  );
};

const IconFeature = ({ Icon, text }) => (
  <motion.div 
    className="flex flex-col items-center"
    whileHover={{ scale: 1.05 }}
    transition={{ duration: 0.3 }}
  >
    <Icon className="w-12 h-12 text-green-500 mb-3" />
    <p className="font-semibold text-base">{text}</p>
  </motion.div>
);

export default HeroSection;